export interface SendOtpRequest {
  email: string;
}

export interface SendOtpResponse {
  message: string;
  expiresIn: number;
}

export interface VerifyOtpRequest {
  email: string;
  code: string;
}

export interface AuthToken {
  access_token : string;
  expiresAt: string;
  deviceId: string;
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  tenantId: string;
  tenantSlug: string;
  avatarUrl?: string;
  plan: PlanPayload | null;
}

export type UserRole = 'admin' | 'recrutadora';

export function normalizeUserRole(role: string | null | undefined): UserRole {
  const valor = (role ?? '').trim().toLowerCase();
  return valor === 'admin' ? 'admin' : 'recrutadora';
}

export function normalizeUserProfile(user: UserProfile): UserProfile {
  return { ...user, role: normalizeUserRole(user.role as string) };
}

/** Subset of plan info delivered by GET /api/auth/me — fed into PlanService. */
export interface PlanPayload {
  status: string;            // "TRIAL" | "ATIVO" | "INADIMPLENTE" | "CANCELADO"
  planoAtual: string;        // codigo: SOLO, CONSULTORIA, AGENCIA, ENTERPRISE, TRIAL (uppercase no DB)
  planoNome?: string | null; // Nome exibivel vindo de AssinaturaPlano.Nome (ex.: "Solo", "Consultoria")
  trialEndsAt: string | null;
  jobsUsed: number;
  jobsTotal: number;
  talentsUsed: number;
  talentsTotal: number;
  aiCreditsUsed: number;
  aiCreditsTotal: number;
  aiCreditsExtra: number;
  monthlyPrice?: number | null;
  renewalDate?: string | null;
}
